export default __webpack_public_path__ + "static/media/nabh_accredited.8dd660d2.jpg";